/**
 * Dymki otwierane z paska narzędzi tabeli mają jedną obudowę — ten sam
 * promień co przyciski paska i to samo wypełnienie, żeby panel filtrów
 * i lista kolumn nie wyglądały jak dwa różne zestawy.
 */
export const toolbarPopoverClass = 'rounded-md p-2';
